import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { RootStoreState } from '@app/root-store';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { AuthService, ClosedSideNavTemplate, CommonService, DocumentService } from '@app/shared/services';
import { ChecklistService } from '@app/shared/services/checklist/checklist.service';
import { CryptoService } from '@app/shared/services/crypto/crypto.services';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, Observable, Subscription } from 'rxjs';
// import { Input } from 'vis-network/declarations/module/hammer';
// import { Input } from 'vis-network/declarations/module/hammer';
import * as loginSelector from '../../../root-store/login-store/login.selector';
import * as vaultSelector from '../../../root-store/vault-store/vault.selector';
ContactUsDialogComponent;
// import * as data from './data.json';
import { HttpErrorResponse } from '@angular/common/http';
import { AddDocumentComponent } from '@app/modules/vault/components/add-document/add-document.component';
import { ContactUsDialogComponent } from '@app/modules/vault/components/dialogs/contact-us-dialog/contact-us-dialog.component';
import { VaultSideNavService } from '../../../modules/vault/container/vault.side-nav.service';
import { fetchUserAttributes } from '@aws-amplify/auth';

// import * as templatecategories from '../../../../../assets/json/templatecategories.json';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'view-template',
  templateUrl: './view-template.component.html',
  styleUrls: ['./view-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewTemplateComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav') public sidenav: MatSidenav;
  @Output() someEvent = new EventEmitter<string>();
  @Input() is_filter;
  @Input() is_filter_name;
  @Input() group_id;
  @Input() parent_vault_user_location_id;

  @Input() sub_location_Enable = false;
  vaultStateObject$: any;
  defaultFolders;
  getAllForms = [];
  openMenuDrawer = false;
  @Input() is_linked_form_id;

  @Input() isLinked = false;

  @Input() Linked_form_name = null;
  filteredList;
  isClicked = null;
  currentFolderName;
  loginStateObject$: any;
  loginData;
  recentlyUsed;
  isAllTemplates = false;
  isProfessionalTemplate = false;
  commenlyUsed;
  myFolderListData;
  searchForm: UntypedFormGroup;
  searchedStr: string = '';
  SearchedFormArray;
  searchClicked: boolean = false;
  loading: boolean = false;
  checkedItemsArray: Array<any> = [];
  commenlyUsedVaultFolderList;
  allTemplateForm: any[] = [];
  professionalForm;
  screenWidth: number;
  isSearchactive: boolean = false;
  checklistShortOrderMax;
  isexpanded: boolean = true;
  checklistTotalCount: number = 0;
  checklistForm: Array<any> = [];
  checklistTotalList: Array<any> = [];
  isProfessional$;
  resizeObservable$: Observable<Event>;
  vaultStateObject;
  subscription: Subscription = new Subscription();
  securityStateObject;
  vaultUserID$ = this.store.pipe(select(vaultSelector.getcurrentVaultUserId()));
  fullDropDonwList = [];
  selectedCategoryName = '';
  isListLoaded = false;
  documentUploaded;
  ShowLocatioOrIsassets = false;

  categoryType = 'vault';
  // is_filter = 'Travel';
  // is_filter_name = 'Documents';
  folderId;
  isCheckBox;
  userId = 2;
  hideAllTemplates;
  checklist_id;

  estate_asset_tab_id;
  estate_tab_group_id;
  sortOrderIdMax;
  type;
  createFileMode;
  opened = true;
  templateCategories;
  templateCategoriesSection;
  categoryIndex;
  subSectionName;

  isImpersonating: boolean = false;
  openMobileMenuDrawer: boolean = false;
  openMobileSearch: boolean = false;
  formCardsArray: any[] = [];
  isCommonServiceLoading: boolean = true;
  navCount = 0;
  hasSubjectData = undefined;
  constructor(
    private vaultService: VaultStoreEffects,
    private cd: ChangeDetectorRef,
    private checklistService: ChecklistService,
    private commonService: CommonService,
    private documentService: DocumentService,
    private cryptoService: CryptoService,
    private loginService: LoginStoreEffects,
    private closedSideNavTemplate: ClosedSideNavTemplate,
    private dialog: MatDialog,
    private router: Router,
    private _fb: UntypedFormBuilder,
    private toastr: ToastrService,
    private store: Store,
    private store$: Store<RootStoreState.State>,

    private authService: AuthService,
    private sideNavService: VaultSideNavService
  ) {
    this.vaultStateObject$ = this.vaultService.vaultObject;

    this.subscription.add(
      this.store.select(vaultSelector.getCategoriesOnType(this.categoryType)).subscribe((response) => {
        this.defaultFolders = [...response];
        this.cd.detectChanges();
      })
    );
    this.subscription.add(
      this.closedSideNavTemplate.getMessage().subscribe((res) => {
        if (res?.text == 'true') {
          this.sidenav.opened = false;
          this.closeSideNav();
        }
      })
    );

    this.loginStateObject$ = this.loginService.loginObject;
    this.subscription.add(
      this.loginStateObject$.subscribe((state) => {
        this.loginData = { ...state.data };
      })
    );

    this.isProfessional$ = this.store.select(loginSelector.getUseIsproefessional);

    // get user all details and indentify is user impersonating
    this.subscription.add(
      this.store.pipe(select(loginSelector.getCurrentUserFullDetails)).subscribe(async (result) => {
        try {
          const authUser = this.authService.user;
          if (result?.switch_from_user_id && result?.id != authUser['id']) {
            this.isImpersonating = true;
          } else {
            this.isImpersonating = false;
          }
        } catch (ex) {}
      })
    );
  }

  ngOnInit(): void {
    this.subscription.add(
      this.vaultStateObject$.subscribe((item) => {
        this.getAllForms = [];
        this.vaultStateObject = item;

        this.documentUploaded = item.forms?.find((x) => x.id == 57);

        if (this.is_filter != -1) {
          // get templates by category
          item.forms.forEach((form) => {
            const filteredData = form['folders'].filter((folder) => folder.vaultfolderid == this.is_filter);
            if (filteredData.length > 0) this.getAllForms.push(form);
          });
        } else {
          if (this.is_filter_name == 'Location') {
            // get location templates
            item.forms.forEach((form) => {
              //HAS LOCATION AND SUB LOCATION
              if (form.template_is?.includes('Location')) {
                this.getAllForms.push(form);
              }
            });
          } else {
            // get all templates
            this.getAllForms = item.forms;
          }
        }
        this.getAllForms = this.getAllForms.map((p: any) => {
          return {
            ...p,
            is_checked: false,
          };
        });

        if (this.is_filter != -1) {
          // this.filteredList = this.getAllForms;

          const myCurrentFolderItem = this.defaultFolders.filter((item) => {
            return item.id === this.is_filter;
          });

          this.currentFolderName = myCurrentFolderItem[0];

          // getting common forms for the folders START
          this.commenlyUsedVaultFolderList = this.getAllForms.filter((list) => {
            return list.commonly_used_vault_folder_list;
          });

          this.commenlyUsed = this.commenlyUsedVaultFolderList
            .filter((form) => form.commonly_used_vault_folder_list.includes(this.currentFolderName.id))
            .map((items) => {
              return items;
            });

          // getting common forms for the folders END
          this.isAllTemplates = false;
          this.searchClicked = false;
          this.isClicked = this.currentFolderName.id;
          this.cd.detectChanges();
        }

        //end
      })
    );

    this.subscription.add(
      this.commonService.getTemplateCategories().subscribe(
        (data) => {
          this.templateCategories = data.filter((category) => {
            return category.category_id == this.is_filter;
          });
          this.isCommonServiceLoading = false;
          this.cd.detectChanges();
          this.templateCategoriesSection = this.templateCategories[0].section;
          this.setDafiltValue();
        },
        (error: HttpErrorResponse) => {}
      )
    );

    this.screenWidth = window.innerWidth;
    if (this.screenWidth > 480) {
      this.openMenuDrawer = true;
    } else {
      this.openMenuDrawer = true;
    }
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    this.searchForm = this._fb.group({
      searchedValue: [''],
    });
    this.subscription.add(
      this.commonService.locationTemplateDataSubject.subscribe((data) => {
        if (data) {
          this.hasSubjectData = data;
          this.cd.detectChanges();
        }
      })
    );

    if (this.is_filter == -1) {
      const assets = {
        category_type: 'estate',
        id: 9,
        image: 'asset.svg',
        is_active: 1,
        name: 'Assets',
        sort_order: 0,
        tooltip: null,
        tutorial_embedcode: 'ix435fllsu',
      };
      this.getFolderList(
        this.hideAllTemplates ? assets : this.getAllForms,
        this.hideAllTemplates ? '' : 'allTemplate',
        this.hideAllTemplates ? 9 : 105
      );
      this.cd.detectChanges();
    } else {
      // this line below is the first line needed to temporary fix/hack to show filtered templates
      this.getFolderList(this.getAllForms, this.hideAllTemplates ? '' : 'allTemplate', this.hideAllTemplates ? 9 : 105);
    }
  }

  ngAfterViewInit() {
    this.subscription.add(
      this.commonService.sideNavToggleSubject.subscribe((data) => {
        this.sidenav.toggle();
        this.cd.detectChanges();
      })
    );
  }

  setDafiltValue() {
    this.categoryIndex =
      this.templateCategories.findIndex((x) => x.category_id == this.is_filter) != -1
        ? this.templateCategories.findIndex((x) => x.category_id == this.is_filter)
        : 0;
    if (this.templateCategories.length && this.templateCategoriesSection.length) {
      this.templateCategories[this.categoryIndex].section[0].is_active = true;
      this.templateCategories[this.categoryIndex].section[0].is_list_loaded = true;
      this.selectedCategoryName = this.templateCategories[this.categoryIndex].section[0].section_name;
      this.subSectionName = this.templateCategories[this.categoryIndex].section[0].sub_section.filter((section) => {
        return section;
      });
      this.filteredList = this.getAllForms.filter((form) => {
        return form?.section == this.selectedCategoryName;
      });
    }
    // clear search
    this.clearSearchAction();
    // get form cards array
    this.getFormCardsArray();
    this.cd.markForCheck();
  }

  togglemenu(listName: string, index) {
    // clear search
    this.templateCategories[this.categoryIndex].section[index].is_active = true;
    this.templateCategories[this.categoryIndex].section[index].is_list_loaded = true;
    this.selectedCategoryName = this.templateCategories[this.categoryIndex].section[index].section_name;
    this.filteredList = this.getAllForms.filter((form) => {
      return form?.section == this.selectedCategoryName;
    });

    this.templateCategories.forEach((element, currentIndex) => {
      element.section.forEach((element, chiledIndex) => {
        if (chiledIndex != index) {
          this.templateCategories[this.categoryIndex].section[chiledIndex].is_active = false;
          this.templateCategories[this.categoryIndex].section[chiledIndex].is_list_loaded = false;
        }
      });
    });

    this.subSectionName = this.templateCategoriesSection[index].sub_section;
    // get forms array
    this.getFormCardsArray();
    // close mobile drawer menu
    this.openMobileMenuDrawer = !this.openMobileMenuDrawer;
    // clear search
    this.clearSearchAction();
    this.cd.detectChanges();
  }

  resetAll() {
    this.templateCategories.forEach((element, index) => {
      if (element.section?.length) {
        element.section.forEach((element, chiledIndex) => {
          this.templateCategories[index].section[chiledIndex].is_active = false;
          this.templateCategories[index].section[chiledIndex].is_list_loaded = false;
        });
      }
    });
  }

  closeSideNav() {
    this.sidenav.close();
    this.commonService.locationTemplateDataSubject.next(undefined);
    try {
      this.someEvent.next('somePhone');
    } catch (error) {}
    this.cd.detectChanges();
  }

  getFolderList(item, str, index) {
    if (str == 'allTemplate') {
      this.isClicked = index;
      // this.currentFolderName = null;
      this.isAllTemplates = true;
      this.searchClicked = false;
      this.isSearchactive = false;
      this.searchedStr = '';
      this.isProfessionalTemplate = false;
      if (this.hasSubjectData) {
        const commenlyUsedFilter = this.getAllForms.filter((list) => {
          return list.commonly_used_vault_folder_list;
        });
        this.commenlyUsed = commenlyUsedFilter.filter((template) =>
          template.onboarding_tags.toLowerCase().includes(this.hasSubjectData.tag.toLowerCase())
        );
        const allTemplateFilter = this.getAllForms.filter((list) => {
          return list.commonly_used_vault_folder_list == null;
        });
        this.allTemplateForm = allTemplateFilter.filter((template) =>
          template.onboarding_tags.toLowerCase().includes(this.hasSubjectData.tag.toLowerCase())
        );

        let findActiveCategory = this.templateCategories.find((x) => x.is_list_loaded == true);
        if (findActiveCategory?.sublist?.length) {
          let subcategoryName = findActiveCategory?.sublist.find((x) => x.is_active == true)?.name?.toLowerCase();
          if (subcategoryName != null && subcategoryName != undefined) {
            this.commenlyUsed = this.commenlyUsed.filter((x) => x.subcategories_list.toLowerCase().indexOf(subcategoryName) >= 0);
            this.allTemplateForm = this.allTemplateForm.filter((x) => x.subcategories_list.toLowerCase().indexOf(subcategoryName) >= 0);
          }
        }
      } else {
        this.commenlyUsed = this.getAllForms.filter((list) => {
          return list.commonly_used_vault_folder_list;
        });

        this.allTemplateForm = this.getAllForms.filter((list) => {
          return list.commonly_used_vault_folder_list == null;
        });

        let findActiveCategory = this.templateCategories.find((x) => x.is_list_loaded == true);
        if (findActiveCategory?.sublist?.length) {
          let subcategoryName = findActiveCategory?.sublist.find((x) => x.is_active == true)?.name?.toLowerCase();
          if (subcategoryName != null && subcategoryName != undefined) {
            this.commenlyUsed = this.commenlyUsed.filter((x) => x.subcategories_list.toLowerCase().indexOf(subcategoryName) >= 0);
            this.allTemplateForm = this.allTemplateForm.filter((x) => x.subcategories_list.toLowerCase().indexOf(subcategoryName) >= 0);
            // this.commenlyUsedVaultFolderList = this.commenlyUsedVaultFolderList.filter(x => x.search_tokens.toLowerCase().includes(subcategoryName));
          }
        }
      }
      // this line below is the second line needed to temporary fix/hack to show filtered templates
      if (this.is_filter_name !== 'allTemplate' && this.is_filter !== -1) {
        this.searchClicked = false;
        this.isSearchactive = false;
        this.isAllTemplates = false;
        this.searchedStr = '';
      }
      this.cd.detectChanges();
    } else if (str == 'professional') {
      this.isClicked = index;
      this.currentFolderName = null;
      this.isAllTemplates = false;
      this.searchClicked = false;
      this.isSearchactive = false;
      this.searchedStr = '';
      this.isProfessionalTemplate = true;

      this.professionalForm = this.getAllForms.filter((list) => {
        return list.is_professional_template == true;
      });

      this.cd.detectChanges();
    } else {
      let folders;
      if (this.ShowLocatioOrIsassets) {
        // folders = this.getAllForms;
        this.filteredList = this.getAllForms;
      } else {
        // folders = this.getAllForms.map((formitem) => {
        //   if (
        //     formitem.folders.find((items) => {
        //       return items.vaultfolderid == item.id;
        //     })
        //   )
        //     return formitem;
        // });
        item.forms.forEach((form) => {
          const filteredData = form['folders'].filter((folder) => folder.vaultfolderid == this.is_filter);
          if (filteredData.length > 0) this.getAllForms.push(form);
        });
        this.filteredList = this.getAllForms;
      }

      // this.filteredList = folders.filter((data) => {
      //   return data !== undefined;
      // });

      this.isClicked = index;
      this.currentFolderName = item;
      this.isAllTemplates = false;
      this.searchClicked = false;
      this.isSearchactive = false;
      this.searchedStr = '';
      this.isProfessionalTemplate = false;

      this.commenlyUsedVaultFolderList = this.getAllForms.filter((list) => {
        return list.commonly_used_vault_folder_list;
      });

      this.commenlyUsed = this.commenlyUsedVaultFolderList
        .filter((form) => form.commonly_used_vault_folder_list.includes(item.id))
        .map((items) => {
          return items;
        });
      this.cd.detectChanges();
      let findActiveCategory = this.fullDropDonwList.find((x) => x.is_list_loaded == true);
      if (findActiveCategory?.sublist?.length) {
        let subcategoryName = findActiveCategory?.sublist.find((x) => x.is_active == true)?.name?.toLowerCase();
        if (subcategoryName != null && subcategoryName != undefined) {
          this.commenlyUsed = this.commenlyUsed.filter((x) => x.subcategories_list.toLowerCase().indexOf(subcategoryName) >= 0);
          this.filteredList = this.filteredList.filter((x) => x.subcategories_list.toLowerCase().indexOf(subcategoryName) >= 0);
          // this.commenlyUsedVaultFolderList = this.commenlyUsedVaultFolderList.filter(x => x.search_tokens.toLowerCase().includes(subcategoryName));
        }
      }
      // if (!this.isAllTemplates && !this.searchClicked && !this.isSearchactive) {
      //   if (document.getElementById('templateCenterFolderView')) {
      //     document.getElementById('templateCenterFolderView').scrollTop = 0;
      //   }
      // }
      if (this.commenlyUsed.findIndex((x) => x.id == 57) != -1) {
        this.commenlyUsed.splice(
          this.commenlyUsed.findIndex((x) => x.id == 57),
          1
        );
      }
      if (this.filteredList.findIndex((x) => x.id == 57) != -1) {
        this.filteredList.splice(
          this.filteredList.findIndex((x) => x.id == 57),
          1
        );
      }
      this.filteredList = [this.documentUploaded].concat(this.filteredList);
      this.commenlyUsed = [this.documentUploaded].concat(this.commenlyUsed);
      this.cd.detectChanges();
    }

    this.allTemplateForm.forEach((template) => {
      template.type_template_Array = template.type_template.split(',');
    });
  }

  addToMyFolders(item) {
    this.closeSideNav();
    let modalRef2: any = {};
    if (this.checklist_id) {
      if (this.isLinked) {
        modalRef2 = this.dialog.open(AddDocumentComponent, {
          disableClose: true,
          data: {
            isintelligent: true,
            form_id: item.id,
            folder_id: item.type,
            mode: 'edit',
            sub_location_Enable: this.sub_location_Enable,
            group_id: this.group_id,
            is_filter_name: this.is_filter_name,
            parent_vault_user_location_id: this.parent_vault_user_location_id,
            is_linked_form_id: this.is_linked_form_id,
            checklist_id: this.checklist_id,
            isLinked: true,
            Linked_form_name: this.Linked_form_name,
          },
          panelClass: 'full-window-dialog-black-board',
          autoFocus: false,
        });
      } else {
        modalRef2 = this.dialog.open(AddDocumentComponent, {
          disableClose: true,
          data: {
            isintelligent: true,
            form_id: item.id,
            sub_location_Enable: this.sub_location_Enable,
            folder_id: item.type,
            mode: 'edit',
            is_filter_name: this.is_filter_name,
            parent_vault_user_location_id: this.parent_vault_user_location_id,
            group_id: this.group_id,
            Linked_form_name: this.Linked_form_name,
            checklist_id: this.checklist_id,
          },
          panelClass: 'full-window-dialog-add-document',
          autoFocus: false,
        });
      }
    } else {
      if (this.isLinked) {
        modalRef2 = this.dialog.open(AddDocumentComponent, {
          disableClose: true,
          data: {
            isintelligent: true,
            form_id: item.id,
            group_id: this.group_id,
            folder_id: item.type,
            mode: 'edit',
            sub_location_Enable: this.sub_location_Enable,
            isLinked: true,
            is_filter_name: this.is_filter_name,
            parent_vault_user_location_id: this.parent_vault_user_location_id,
            Linked_form_name: this.Linked_form_name,
            is_linked_form_id: this.is_linked_form_id,
            estate_asset_tab_id: this.estate_asset_tab_id,
            estate_tab_group_id: this.estate_tab_group_id,
          },
          panelClass: 'full-window-dialog-black-board',
          autoFocus: false,
        });
      } else {
        modalRef2 = this.dialog.open(AddDocumentComponent, {
          disableClose: true,
          data: {
            isintelligent: true,
            sub_location_Enable: this.sub_location_Enable,
            form_id: item.id,
            is_filter_name: this.is_filter_name,
            parent_vault_user_location_id: this.parent_vault_user_location_id,
            group_id: this.group_id,
            Linked_form_name: this.Linked_form_name,
            folder_id: item.type,
            mode: 'edit',
            estate_asset_tab_id: this.estate_asset_tab_id,
            estate_tab_group_id: this.estate_tab_group_id,
          },
          panelClass: 'full-window-dialog-add-document',
          autoFocus: false,
        });
      }
    }
    this.subscription.add(
      modalRef2.afterClosed().subscribe((result) => {
        this.closeSideNav();
      })
    );
  }

  getSearchedForms(searchedValue) {
    this.searchedStr = searchedValue;

    // step-1 : filter on type
    let filteredOnType = this.getAllForms
      .filter((form) => form.type.toLowerCase().includes(this.searchedStr.toLowerCase()))
      .map((item) => {
        return item;
      });

    // step-2 : filter on search token
    let filteredOnToken = this.getAllForms
      .filter((form) => form.search_tokens.toLowerCase().includes(this.searchedStr.toLowerCase()))
      .map((item) => {
        return item;
      });

    // step-3 : create new array by remove the duplicates

    // step 3-a : Lexicographically sorting based upon the type of form
    filteredOnType = filteredOnType.sort(function (a, b) {
      return a.type.localeCompare(b.type);
    });

    filteredOnToken = filteredOnToken.sort(function (a, b) {
      return a.type.localeCompare(b.type);
    });

    let newArray = filteredOnToken.concat(filteredOnType);
    this.SearchedFormArray = newArray = [...new Set([...filteredOnType, ...filteredOnToken])];
    if (this.SearchedFormArray.findIndex((x) => x.id == 57) != -1) {
      this.filteredList.splice(
        this.SearchedFormArray.findIndex((x) => x.id == 57),
        1
      );
      this.SearchedFormArray = [this.documentUploaded].concat(this.SearchedFormArray);
    }

    // removing the active state & hiding other fields - for listitem hover
    this.searchClicked = true;
    this.isClicked = null;

    // if searchStr is empty then move to the alltemplate
    if (this.searchedStr.length == 0 && this.categoryType !== 'estate') {
      this.isAllTemplates = true;
      this.isClicked = 105;
      this.SearchedFormArray.length = 0;
      if (this.searchedStr.length == 0 && this.ShowLocatioOrIsassets) {
        this.getFolderList(null, '', 1);
      } else {
        if (this.isCheckBox) {
          this.getFolderList(this.getAllForms, 'allTemplate', 105);
        } else {
          this.setDafiltValue();
        }
      }
    }
    if (this.searchedStr.length == 0 && this.ShowLocatioOrIsassets) {
      this.getFolderList(null, '', 1);
    }
    if (this.searchedStr.length) {
      this.resetAll();
    }

    if (this.searchedStr.length == 0 && this.categoryType == 'estate') {
      const assets = {
        category_type: 'estate',
        id: 9,
        image: 'asset.svg',
        is_active: 1,
        name: 'Assets',
        sort_order: 0,
        tooltip: null,
        tutorial_embedcode: 'ix435fllsu',
      };

      this.getFolderList(assets, '', 9);
    }
  }

  closetMatDrawer() {
    if (this.screenWidth <= 480) {
      this.openMenuDrawer = false;
    }
  }

  clearSearch() {
    this.searchedStr = '';
    this.isSearchactive = false;

    if (this.categoryType == 'estate') {
      const assets = {
        category_type: 'estate',
        id: 9,
        image: 'asset.svg',
        is_active: 1,
        name: 'Assets',
        sort_order: 0,
        tooltip: null,
        tutorial_embedcode: 'ix435fllsu',
      };

      this.getFolderList(assets, '', 9);
    } else {
      this.isAllTemplates = true;
      this.isClicked = 105;
      this.SearchedFormArray.length = 0;
      if (this.ShowLocatioOrIsassets) {
        this.getFolderList(null, '', 1);
      } else {
        if (this.isCheckBox) {
          this.getFolderList(this.getAllForms, 'allTemplate', 105);
        } else {
          this.setDafiltValue();
        }
      }
    }
    this.cd.detectChanges();
  }

  handleNav(e) {
    this.sideNavService.handleVaultSideNav(e);
    if (e) this.ngOnInit();
    if (e) this.navCount++;
    this.sideNavService.handleNav(e);
    this.commonService.isClose(e);
    this.cd.detectChanges();
  }

  // method to get form cards
  getFormCardsArray() {
    let newFilteredList: any[] = [];
    newFilteredList = this.getAllForms?.filter((item) => item?.section_subsection_rank?.includes(this.selectedCategoryName));
    this.formCardsArray = newFilteredList;
    this.formCardsArray?.forEach((template) => {
      template.type_template_Array = template?.type_template.split(',');
    });
    // this.cd.detectChanges();
  }
  showSubSection(subSectionName: string) {
    let length: number = this.formCardsArray?.filter((item) => item?.section_subsection_rank?.includes(subSectionName)).length;
    return length;
  }

  // method to perform search templates
  searchTemplates(searchText: string) {
    // reset all if search text length is 0
    if (searchText.length == 0) {
      this.clearSearchAction();
    }
    // perform search
    else {
      // set searched str for user type value
      this.searchedStr = searchText;
      // set search clicked true & show search list
      this.searchClicked = true;
      // search possible results from the main array
      // filter on type
      let filteredOnType = this.getAllForms
        .filter((form) => form.type.toLowerCase().includes(this.searchedStr.toLowerCase()))
        .map((item) => {
          return item;
        });
      // filter on search token
      let filteredOnToken = this.getAllForms
        .filter((form) => form.search_tokens.toLowerCase().includes(this.searchedStr.toLowerCase()))
        .map((item) => {
          return item;
        });
      // create new array based on above filtered results
      this.SearchedFormArray = [...new Set([...filteredOnType, ...filteredOnToken])];
    }
  }

  // method to clear search
  clearSearchAction() {
    // set searched str empty
    this.searchedStr = '';
    // set search clicked false & hide search list
    this.searchClicked = false;
    // set search form array empty
    this.SearchedFormArray = [];
  }

  // method to handle mobile menu drawer
  handleMobileMenuDrawer() {
    this.openMobileMenuDrawer = !this.openMobileMenuDrawer;
  }

  // method to handle mobile search
  handleMobileSearch() {
    this.openMobileSearch = !this.openMobileSearch;
  }

  // ============================================================ The below part not chnaged l====================================
  toggle(event, id) {
    if (event.source.checked) {
      this.checkedItemsArray.push(event.source.id);

      this.getAllForms.map((item) => {
        if (item.id == id) {
          return (item.is_checked = true);
        }
      });
    } else if (!event.source.checked) {
      this.checkedItemsArray = this.checkedItemsArray.filter((item) => item !== event.source.id);

      this.getAllForms.map((item) => {
        if (item.id == id) {
          return (item.is_checked = false);
        }
      });
    }
  }

  // Mobile
  toggleSearch() {
    this.isSearchactive = true;
    this.isClicked = null;
    this.isAllTemplates = false;
  }

  setSubListActive(child_index, root_index) {
    this.fullDropDonwList[root_index].sublist.forEach((element, index) => {
      this.fullDropDonwList[root_index].sublist[index].is_active = false;
    });
    this.fullDropDonwList[root_index].sublist[child_index].is_active = true;
    const data = {
      id: this.fullDropDonwList[root_index].l_id,
      name: this.fullDropDonwList[root_index].name,
      image: this.fullDropDonwList[root_index].image,
    };
    this.selectedCategoryName = this.fullDropDonwList[root_index].sublist[child_index].name;
    this.getFolderList(data, '', this.fullDropDonwList[root_index].l_id);
    this.cd.detectChanges();
  }

  createChecklistForm(item) {
    this.checklistForm.push({ itemLength: 0, ...item });
    this.checklistTotalList.push(item);

    this.checklistForm = this.checklistForm.map((res) => {
      if (res.id == item.id) {
        res.itemLength = res.itemLength + 1;
      }
      return res;
    });

    this.checklistForm = Array.from(new Set(this.checklistForm.map((i) => i.id))).map((id) => {
      return this.checklistForm.find((a) => a.id === id);
    });

    this.checklistTotalCount = 0;
    this.checklistForm.forEach((item) => {
      this.checklistTotalCount = this.checklistTotalCount + item.itemLength;
    });
  }

  async createFile(checklistformList, userPk, currentUrl, userId, isDialog, dialogRef?) {
    await Promise.all(
      checklistformList.map(async (item) => {
        const promise = await new Promise((resolve, reject) => {
          const data = {
            url: currentUrl,
            user_id: userId,
            vault_form_id: item.vault_form_id,
            vaultId: this.vaultStateObject.vaultId,
          };
          this.subscription.add(
            this.documentService.getforIdForFirstUploadDocument(data, loaderTypes.default).subscribe(
              (res) => {
                const usersPk = userPk;
                this.securityStateObject = res['vault_user_form_id'].public_key;
                const form_encryption_key = this.cryptoService.generateEncryptionKey(usersPk, null, null);
                const url = currentUrl.split('/');
                const data = {
                  user_id: userId,
                  user_pk: usersPk,
                  id: res.vault_user_form_id.vault_user_form_id,
                  vault_folder_id: null,
                  vault_user_folder_id: url[3],
                  form_data: null,
                  workspace_folder_id: null,
                  notes: null,
                  physical_location: null,
                  form_name: item.type,
                  encryption_key: form_encryption_key.encrypted,
                  origin: 'vault',
                  expiration_date: null,
                  expiration_notification: null,
                  recurring_expiration: null,
                  security_key: null,
                };
                this.subscription.add(
                  this.documentService.saveformDataForChecklistSetup(data, loaderTypes.default).subscribe((res) => {
                    if (isDialog) {
                      this.loading = false;
                      dialogRef.close({ confirmation: true });
                    }
                  })
                );
              },
              (error) => {
                resolve('');
              }
            )
          );
        });
      })
    );
  }

  toggleChecklistItems() {
    this.isexpanded = !this.isexpanded;
  }

  removeChecklist(item) {
    this.checklistTotalList.splice(
      this.checklistTotalList.findIndex((a) => a.id === item.id),
      1
    );

    this.checklistForm = this.checklistForm.map((res) => {
      if (res.id == item.id) {
        res.itemLength = res.itemLength - 1;
      }
      return res;
    });

    this.checklistForm = this.checklistForm.filter((res) => res.itemLength >= 1);
  }

  updateChecklist(item) {
    // const payload = [
    //   {
    //     id: this.data?.form.id,
    //     vault_form_id: item.id,
    //   },
    // ];
    // this.subscription.add(
    //   this.checklistService.updateChecklist(payload).subscribe((res) => {
    //     this.toastr.success('Template has been updated');
    //     this.dialogRef.close({ confirmation: true });
    //   })
    // );
  }

  contactAdminCenter() {
    const dialogRef = this.dialog.open(ContactUsDialogComponent, {
      disableClose: true,
      data: {
        title: 'Tell us what you want',
      },
      panelClass: this.screenWidth <= 480 ? 'full-window-dialog-2' : 'contact-us-dialog',
    });
    this.subscription.add(dialogRef.afterClosed().subscribe((confirmation) => {}));
  }

  ngOnDestroy() {
    this.is_filter = '';
    this.subscription?.unsubscribe();
  }
}
